import { Box, Grid, GridItem } from '@chakra-ui/react'
import type { ReactNode } from 'react'
import { PrimaryNav } from './PrimaryNav'
import { TopBar } from './TopBar'

type AppShellProps = { currentPath: string; children: ReactNode }

// The top-level page grid: a fixed header row, an auto-height nav row, and a
// flexible content row. The content region carries the `main-root-window` id
// that playground and image-export code targets directly - do not rename it.
export function AppShell({ currentPath, children }: AppShellProps) {
  return (
    <Grid templateRows="64px auto 1fr" templateAreas={'"header" "nav" "content"'} minH="100vh">
      <GridItem area="header">
        <TopBar />
      </GridItem>
      <GridItem area="nav">
        <PrimaryNav currentPath={currentPath} />
      </GridItem>
      <GridItem area="content" overflow="auto" minH="0">
        <Box
          id="main-root-window"
          display="flex"
          flexDirection="column"
          overflow="auto"
          h="100%"
          p={6}
        >
          {children}
        </Box>
      </GridItem>
    </Grid>
  )
}
